import gql from "graphql-tag";
const ADD_EMAILS_TEMPLATES = gql `
  mutation addEmailsTemplate($emailsTemplateAddInput: EmailsTemplateAddInput!) {
    addEmailsTemplate(emailsTemplateAddInput: $emailsTemplateAddInput) {
      id
    }
  }
`;
export default ADD_EMAILS_TEMPLATES;
